import cn from 'classnames';
import type { ReactNode } from 'react';

export type SectionProperties = {
  children?: ReactNode;
  className?: string;
  lineBottom?: boolean;
  lineTop?: boolean;
  paddingBottom?: boolean;
  paddingTop?: boolean;
};

const Section = ({
  className,
  lineBottom = true,
  lineTop = false,
  paddingBottom = true,
  paddingTop = true,
  ...rest
}: SectionProperties) => (
  <div
    className={cn('form__section', className, {
      'form__section-bottom': lineBottom,
      'form__section-bottom-padding': paddingBottom,
      'form__section-top': lineTop,
      'form__section-top-padding': paddingTop,
    })}
    {...rest}
  />
);

export default Section;
